<template>
    <div class="task-form">
        <div class="form-content">
            <div class="step-0" v-if="step === 0">
                <b-row>
                    <b-col cols="12">
                        <app-form-input label="Título" required v-model="task.name"></app-form-input>
                    </b-col>
                    <b-col cols="12" class="mb-4">
                        <vue-editor required v-model="task.description"></vue-editor>
                    </b-col>
                    <b-col cols="12" md="6">
                        <app-form-input label="Fecha límite" type="datetime-local" v-model="task.dueDate"></app-form-input>
                    </b-col>
                    <b-col cols="12" md="6">
                        <app-form-select
                            label="Visibilidad"
                            :options="taskVisibilityOptions"
                            textField="text"
                            valueField="value"  
                            v-model="task.isPublic"
                            :resultFormat="'value'" 
                        ></app-form-select>
                    </b-col>
                    <b-col cols="12">
                        <app-form-input v-model="task.petitionCode" label="# De ticket asociado" type="number"></app-form-input>
                        <small class="input-help-text">Registra el número del ticket de la PQR asociada</small>
                    </b-col>
                </b-row>
                <b-row class="mt-4">
                    <b-col cols="12" class="mt-2">
                        <app-form-file
                            multiple
                            v-model="files"
                            id="files"
                            v-on:change="handleFileChange"
                            placeholder="Selecciona los archivos"
                            drop-placeholder="Arrastre el archivo acá..."
                            accept=".xlsx, .xls, image/*, .doc, .docx, .ppt, .pptx, .txt, .pdf"
                            :file-name-formatter="filesNameFormatter"
                        ></app-form-file>
                    </b-col>
                    <!-- Archivos previamente cargados -->
                    <b-col cols="12">
                        <b-alert :variant="validFilesSize ? 'warning' : 'danger'" class="mt-2" :show="!!oldFiles.length">
                            <ol>
                                <li v-for="(file, index) in oldFiles" :key="index" class="d-flex justify-content-between">
                                    {{ file.name }} ({{ (file.size / 1000 / 1000) | decimal(2) }}MB)
                                    <b-checkbox v-model="filesToDelete" :value="file.id"><i class="fas fa-trash"></i></b-checkbox>
                                </li>
                            </ol>
                        </b-alert>
                    </b-col>
                </b-row>
                <b-row class="m-3">
                    <b-col cols="12">
                        <b-alert :variant="validFilesSize ? 'info' : 'danger'" class="mt-2" :show="!!selectedFiles.length">
                            <ol>
                                <li v-for="(file, index) in selectedFiles" :key="index" class="mt-2">
                                    {{ file.name }} ({{ (file.size / 1000 / 1000) | decimal(2) }}MB)
                                    <b-btn variant="danger" size="sm" title="Eliminar" @click="deleteFile(index)"><i class="fas fa-trash"></i></b-btn>
                                </li>
                            </ol>
                        </b-alert>
                    </b-col>
                </b-row>
            </div>
            <div class="step-1" v-if="step === 1">
                <b-row>
                    <b-col class="d-flex">
                        <b-form-radio @change="users = []" v-model="assignationType" value="positions">Por Cargo</b-form-radio>
                        <b-form-radio @change="users = []" class="ml-3" v-model="assignationType" value="venues">Por Sede</b-form-radio>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6">
                        <div class="mt-2" v-if="assignationType === 'positions'">
                        <app-options-picker :options="positions" v-model="selectedPositions" label="Seleccione los cargos"></app-options-picker>
                        </div>
                        <div class="mt-2" v-if="assignationType === 'venues'">
                        <app-options-picker :options="venues" v-model="selectedVenues" label="Seleccione las sedes"></app-options-picker>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <app-multi-selector
                        :busy="loadingUsers"
                        :options="users"
                        v-model="selectedPeople"
                        label="Seleccione a las personas para asignar la tarea"
                        ></app-multi-selector>
                    </b-col>
                </b-row>
            </div>
            <div class="form-footer mt-4">
                <b-button variant="secondary" @click="back" :disabled="busy">{{ step === 0 ? 'Cancelar' : 'Atrás' }}</b-button>
                <b-button variant="primary" @click="next" :disabled="busy" class="ml-2">{{ editing ? 'Guardar Cambios' : (step === 0 ? 'Siguiente' : 'Guardar Tarea') }}</b-button>
            </div>
        </div>
    </div>
</template>
<script>
import AppOptionsPicker from '@controls/OptionsPicker.vue'
import { VueEditor } from 'vue2-editor'
export default {
    components: {
        AppOptionsPicker,
        VueEditor,
    },
data: () => ({
    users: [],
    roles: [],
    positions: [],
    selectedVenues: [],
    selectedPeople: [],
    selectedPositions: [],
    venues: [],
    loadingUsers: false,
    files: [],
    step: 0,
    task: {
        name: '',
        dueDate: null,
        description: '',
        petitionCode: '',
        isPublic: 1,
    },
    assignationType: 'positions',
    busy: false,
    editing: false,
    current: null,
    oldFiles: [],
    filesToDelete: [],
    selectedFiles: [],
    taskVisibilityOptions: [
        {
            value: 1,
            text: 'Pública',
        },
        {
            value: 0,
            text: 'Privada',
        },
    ],
}),
    watch: {
        selectedPositions(val) {
            if (!val.length) return (this.users = [])
            this.loadUsers()
        },
        selectedVenues(val) {
            if (!val.length) return (this.users = [])
            this.loadUsers()
        },
        'task.isPublic'(newValue) {
            this.task.isPublic = Number(newValue);
        },
    
    },
    computed: {
        filesSize() {
            const filesSize = this.selectedFiles.reduce((carry, file) => carry + file.size, 0)
            return filesSize / 1000 / 1000
        },
        validFilesSize() {
            return this.filesSize < 9
        },
    },
    methods: {
        handleFileChange(event) {
            // Agregar los nuevos archivos a la lista existente
            for (let i = 0; i < event.target.files.length; i++) {
                this.selectedFiles.push(event.target.files[i]);
            }
        },
        deleteFile(idx) {
            this.selectedFiles.splice(idx, 1)
        },
        cancelFilesSelected() {
            this.files = []
            toastr.success('Archivos cancelados')
        },
        filesNameFormatter(files) {
            return `${files.length} archivos seleccionados`
        },
        async loadRoles() {
            const { data } = await this.$repo.get('roles', { clientAdministrative: 1, sortBy: 'name', sortDir: 'asc' })
            this.roles = data
        },
        async loadVenues() {
            const { data } = await this.$repo.get('venues', { clientId: this.currentClient.id, sortBy: 'name', sortDir: 'asc' })
            this.venues = data
        },
        async loadUsers() {
            try {
            this.loadingUsers = true
            const payload = {
                clientId: this.currentClient.id,
                assignationType: this.assignationType,
                with: 'people.venue:venues.id,venues.name;clientPosition:client_positions.id,client_positions.name',
                sortBy: 'name',
            }
            if (this.assignationType === 'positions') {
                payload['positions'] = this.selectedPositions.join(',')
            } else {
                payload['venues'] = this.selectedVenues.join(',')
            }
            const {
                data: { users },
                } = await this.$repo.post(`clients/${this.currentClient.id}/task-users`, payload)
                this.users = users.map((item) => {
                    let name = item.user_name + (!!item.position_name ? ` - ${item.position_name} ` : '') + (item.venues_name ? ` (${item.venues_name})` : '')
                    if (name.length > 100) {
                        name = name.substring(0, 97) + '...'
                    }
                    return {
                    ...item,
                    id: item.user_id,
                    name: name,
                    }
                })
            } catch (error) {
                console.error({ error })
            } finally {
                this.loadingUsers = false
            }
        },
        async next() {
            if (this.step === 0 && !this.editing) {
                this.step = 1
                return
            }
            if (!this.task.name || !this.task.description) {
                this.step = 0
                return toastr.error('Debes diligenciar el nombre y la descripción de la tarea')
            }
            if (!this.validFilesSize) return toastr.error('Los archivos no deben pesar más de 9 MB')
            try {
                this.busy = true
                // Crear una copia del objeto task para no modificar el original
                const taskToSend = {
                    ...this.task,
                    dueDate: this.task.dueDate ? moment(this.task.dueDate).format('YYYY-MM-DD HH:mm:ss') : null
                }
                const formData = new FormData();
                formData.append('task', JSON.stringify(taskToSend));
                formData.append('clientId', this.currentClient.id);
                formData.append('filesToDelete', this.filesToDelete)
                if (!this.editing) {
                    formData.append('users', this.selectedPeople);
                    formData.append('venues', this.selectedVenues);
                }
                this.selectedFiles.forEach((file, i) => formData.append(`file[${i}]`, file));
                const { data: task } = this.editing
                ? await this.$repo.put(`administrative-tasks/${this.current.id}`, formData) 
                : await this.$repo.post(`administrative-tasks`,  formData )
        
                this.$emit('success', 'Tarea guardada satisfactoriamente')
            } catch (error) {
                toastr.error('Ocurrió un error creando la tarea. Por favor intente de nuevo más tarde')
            } finally {
                this.busy = false
            }
        },
        async back() {
            if (this.step === 0) {
                this.$emit('cancel')
            } else {
                this.step = 0
            }
        },
        async loadPositions() {
            const { data } = await this.$repo.get('positions', { clientId: this.currentClient.id })
            this.positions = data
        },
        edit(task) {
            this.editing = true;
            this.current = { ...task };
            console.log('current', this.current)
            
            this.task = {
                name: task.name,
                description: task.description,
                petitionCode: task.petition_code,
                isPublic: task.is_public, 
                dueDate: task.due_date ? moment(task.due_date).format('YYYY-MM-DDTHH:mm') : null
            };
            this.oldFiles = this.current.files || [];
            this.step = 0;
        },
    },
    
    created() {
        this.loadRoles()
        this.loadPositions()
        if (this.userCan('crear-tarea-administrativa')) {
            this.loadVenues()
        }
    },
}
</script>
<style scoped>
.input-help-text {
    margin-top: -0.5rem;
    display: block;
}
.task-form {
    position: relative;
    min-height: 400px; /* Ajusta este valor según tus necesidades */
    padding-bottom: 100px; /* Espacio para los botones */
}
.form-footer {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 15px;
    width: 100%;
    text-align: right;
    border-top: 1px solid #e9ecef; /* Opcional: añade un borde superior */
}
</style>